import { Injectable } from '@angular/core';
import { RomnasDataService } from '../data-services/romnas-data.service';

@Injectable({
  providedIn: 'root'
})
export class RomnasService {

  constructor(private service: RomnasDataService) { }

  async GetRomnasAutoLoginUrl(model:any):Promise<any>{
    return this.service.GetRomnasAutoLoginUrl(model);
  }
  async ImportRomnasBasket(model:any):Promise<any>{
    return this.service.ImportRomnasBasket(model);
  }
  async DeleteRomnas():Promise<any>{
    return this.service.DeleteRomnas();
}
}
